import { KPI_FIELDS, KpiField, IExternalAgent } from "./IExternalAgent";

interface IProps {
  agent: IExternalAgent;
  handleChange: (field: KpiField, value: boolean) => void;
}

const LABELS: { [K in KpiField]: string } = {
  adl: "ADL",
  best_booker: "Best Booker",
  best_sel: "Best Seller",
  cancelation_ratio: "Cancelation Ratio",
  professional: "Professional",
  amateur: "Amateur",
  beginner: "Beginner",
  group_d: "Group D",
  group_e: "Group E",
  group_f: "Group F",
};

/**
 * Skill flags a workflow can route on. They reach TaskRouter as worker attributes, which is
 * what a queue's target expression matches against.
 *
 * Labels are declared, not derived: the previous capitalise-and-underscore-strip produced
 * "Adl" and "Best sel" for ADL and Best Seller.
 */
const KPIs = ({ agent, handleChange }: IProps) => {
  return (
    <>
      KPIs
      <hr />
      {KPI_FIELDS.map((field) => (
        <div key={field}>
          <label>
            <input
              type="checkbox"
              checked={agent[field]}
              onChange={(e) => handleChange(field, e.target.checked)}
            />
            <span>{LABELS[field]}</span>
          </label>
        </div>
      ))}
    </>
  );
};

export default KPIs;
